<template>
  <div :class="`survey_popup survey_${surveyId}`" v-show="isActive" ref="survey">
    <div class="survey_popup_inner_wrapper">
      <div class="survey_popup_header">
        <h4 class="survey_popup_name">Survey Session</h4>
        <div class="survey_popup_close_btn" @click="close()">&times;</div>
      </div>
      <div class="survey_popup_content_wrapper">
        <div class="survey_popup_content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SurveyPopup',

  props: {
    surveyId: { type: Number },
    pluginId: { type: Number },
    pluginType: { type: String },
    isActive: { type: Boolean }
  },

  data() {
    return {
      content: ''
    }
  },

  watch:{
    content(val) {
      var self = this
      if(val){
        this.$nextTick(()=>{
          self.setupFormSubmit()
        })
      }
    }
  },

  created() {
    this.loadSurvey()
  },

  mounted() {
    this.setScrollableFade()
  },

  methods: {
    close() {
      this.$emit('toggle')
    },
    setScrollableFade() {
      // Hide survey if user scrolls down the page
      $(window).scroll(function() {
          var windowTop = $(window).scrollTop() - 0;
          $('.survey_popup.is_active').each(function(i, obj) {
              var popupTop = $(this).offset().top;

              if (windowTop > popupTop) {
                  $(this).css('opacity','0');
              } else {
                  $(this).css('opacity','1');
              }
          });
      });
    },
    refreshDropdowns() {
      setTimeout(function(){
          $('.selectpicker').selectpicker('refresh');
          $('.dropdown-menu.inner').addClass('show')
      }.bind(this), 0);
    },
    loadSurvey() {
      var self = this
      if (this.surveyId) {
        var params = {
          'embedded': true,
          'is_likeable_survey': true,
          'plugin_id': self.pluginId,
          'plugin_type': self.pluginType
        }
        $.get(`/forms/${this.surveyId}`, params, function(res) {
            self.initSurvey(res.data)
        });
      }
    },
    setupFormSubmit() {
      var self = this
      var $form = $(this.$refs.survey).find('form')

      $form.submit(function(event) {
        event.preventDefault()
        var url = this.getAttribute('action')
        var data = $(this).serialize()

        // Set plugin id and type to pass
        data+=`&plugin_id=${self.pluginId}&plugin_type=${self.pluginType}`

        $.post(url, data, function (res) {
          self.content = '<span class="submitted_msg">Thanks! Your answers have been successfully submitted!</span>'
          $
        })
      })
    },
    initSurvey(data) {
      this.content = data.view
      this.refreshDropdowns()
    }
  }
}
</script>
<style>
  .survey_popup {
    position: absolute;
    bottom: 0;
    max-width: 300px;
    background-color: white;
    padding: 15px;
    border-radius: 15px;
    pointer-events: all;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
    z-index: 10000;
    transition: .3s;
    width: 300px;
    height: 400px;
    overflow: auto;
    opacity: 1;
  }

  .survey_popup_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
  }

  .survey_popup_close_btn {
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 8px;
  }
  .survey_popup input#secondary_submit_btn {
    display: none;
  }
  .survey_popup .row {
    margin: 0;
  }
  .survey_popup .container,
  .survey_popup .form__section-description {
    padding: 0;
  }
  .survey_popup #content,
  .survey_popup .tab-content {
    padding: 0;
  }
  .survey_popup .tab-content {
    padding-bottom: 15px;
  }
  .survey_popup .form-content,
  .survey_popup .tab-content {
    background-color: unset;
  }
</style>